// removed by extract-text-webpack-plugin
module.exports = {"Blackberry":"#333D47","noDecor":"G8a03e4 Gefef6b","base":"Ga8eb7b G8aa691 Gefef6b G5153a3","secondary":"Gce18fe"};